<script setup lang="ts">
import { Checkbox } from '@collector/shared-ui'
import type { Stat } from '@collector/sportsapi-types'

export type Props = {
  disabled?: boolean
}

defineProps<Props>()

const stat = defineModel<Stat>({ required: true })
</script>

<template>
  <div class="mx-4 my-2">
    <Checkbox
      :modelValue="stat.value === null ? false : +stat.value === 1"
      variant="neutral"
      :disabled
      @update:modelValue="stat = { ...stat, value: $event ? '1' : '0' }"
    />
  </div>
</template>
